import { render } from "./CategoriasTable.vue?vue&type=template&id=607e07ef&scoped=true"
import script from "./CategoriasTable.vue?vue&type=script&lang=js"
export * from "./CategoriasTable.vue?vue&type=script&lang=js"

import "./CategoriasTable.vue?vue&type=style&index=0&id=607e07ef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e07ef"]])

export default __exports__